import { createFileRoute } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";

export const Route = createFileRoute("/$lang/glossary")({
  head: ({ params }) => ({
    meta: [
      { title: "Glossary — MadCaptains" },
      { name: "description", content: "Maritime ranks, IMO terms, and the psychological vocabulary used across the archive." },
      { property: "og:title", content: "Glossary — MadCaptains" },
      { property: "og:description", content: "Maritime ranks, IMO terms, and the psychological vocabulary used across the archive." },
      { property: "og:url", content: `/${params.lang}/glossary` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/glossary` }],
  }),
  component: GlossaryPage,
});

function GlossaryPage() {
  const { t } = useI18n();
  const terms = [
    { term: t.glossary_flag_state_term, def: t.glossary_flag_state_def },
    { term: t.glossary_itf_term, def: t.glossary_itf_def },
    { term: t.glossary_iswan_term, def: t.glossary_iswan_def },
    { term: t.glossary_mlc_term, def: t.glossary_mlc_def },
    { term: t.glossary_nautilus_term, def: t.glossary_nautilus_def },
    { term: t.glossary_psc_term, def: t.glossary_psc_def },
    { term: t.glossary_psych_harassment_term, def: t.glossary_psych_harassment_def },
    { term: t.glossary_repatriation_term, def: t.glossary_repatriation_def },
    { term: t.glossary_whistleblower_term, def: t.glossary_whistleblower_def },
  ];
  return (
    <PageShell eyebrow={t.page_glossary_h1} title={t.page_glossary_h1} lead={t.page_glossary_lead}>
      <dl className="divide-y divide-border border-y border-border">
        {terms.map((item, i) => (
          <div key={i} className="py-6">
            <dt className="font-display text-lg">{item.term}</dt>
            <dd className="mt-2 text-justify text-muted-foreground">{item.def}</dd>
          </div>
        ))}
      </dl>
    </PageShell>
  );
}
